import React, { useEffect, useRef } from "react";

export default function GanttChart({ tasks = [], height = 400, viewMode = "Month" }) {
    const ganttRef = useRef(null);

    useEffect(() => {
        if (!tasks || tasks.length === 0) return;

        // 기존 내용 초기화
        ganttRef.current.innerHTML = "";

        new window.Gantt(ganttRef.current, tasks, {
            view_mode: viewMode,
            readonly: true,
            view_mode_select: true,
            arrow_toggle_checkbox: true,
            show_arrows: false,
            activityview: true,
            view_modes: [
                window.Gantt.VIEW_MODE.DAY,
                window.Gantt.VIEW_MODE.WEEK,
                window.Gantt.VIEW_MODE.MONTH
            ],
            milestone_colors: { start: '#0ea5e9', finish: '#f59e0b' },
            status_border_colors: { DELAY: '#ef4444', DONE: '#22c55e', EARLY: '#3b82f6' },
            popup: ({ task }) => `
        <div class="title">${task.name}</div>
        <div class="details">ID: ${task.id}</div>
        <div class="actions">기간: ${task._start?.toLocaleDateString?.()} ~ ${task._end?.toLocaleDateString?.()}</div>
        <div class="actions">진행률: ${task.progress}%</div>
      `,
            holidays: {},
        });
    }, [tasks, viewMode]);

    return <div ref={ganttRef} style={{ width: "100%", minHeight: `${height}px` }} />;
}
